import generateActions from 'utils/actions';

export const SET_VALUE = 'subscriptions/SET_VALUE';
export const PAYWALL_SET_VALUE = 'subscriptions/PAYWALL_SET_VALUE';
export const CLEAR_PLAN = 'subscriptions/CLEAR_PLAN';
export const POST_PLAN = generateActions('subscriptions/POST_PLAN');
export const POST_SUBSCRIBE = generateActions('subscriptions/POST_SUBSCRIBE');
export const POST_UPGRADE = generateActions('subscriptions/POST_UPGRADE');
export const PUT_PLAN = generateActions('subscriptions/PUT_PLAN');
export const DELETE_PLAN = generateActions('subscriptions/DELETE_PLAN');
export const LOAD_PLANS = generateActions('subscriptions/LOAD_PLANS');
export const LOAD_PLAN = generateActions('subscriptions/LOAD_PLAN');
export const LOAD_SUBSCRIPTION = generateActions('subscriptions/LOAD_SUBSCRIPTION');
export const LOAD_INVOICES = generateActions('subscriptions/LOAD_INVOICES');
export const PUT_PAYMENT_METHOD = generateActions('subscriptions/PUT_PAYMENT_METHOD');
export const GET_PAYMENT_METHODS = generateActions('subscriptions/GET_PAYMENT_METHODS');
export const DELETE_PAYMENT_METHOD = generateActions('subscriptions/DELETE_PAYMENT_METHOD');
export const DELETE_SUBSCRIPTION = generateActions('subscriptions/DELETE_SUBSCRIPTION');

export function setPlanValue(name, value) {
  return {
    type: SET_VALUE,
    payload: { name, value }
  };
}

export function setPaywallValue(name, value) {
  return {
    type: PAYWALL_SET_VALUE,
    payload: { name, value }
  };
}

export function clearPlan() {
  return {
    type: CLEAR_PLAN,
  };
}

// Load a single plan by ID
export function loadPlan(id) {
  return {
    types: LOAD_PLAN,
    promise: {
      url: `/billing/plans/${id}`,
    },
  };
}

// Load all plans in the system
export function loadPlans() {
  return {
    types: LOAD_PLANS,
    promise: {
      url: '/billing/plans',
    },
  };
}

// Adds a new plan to the system
export function postPlan(plan) {
  return {
    types: POST_PLAN,
    promise: {
      url: '/billing/plans',
      method: 'POST',
      data: {
        ...plan,
        features: JSON.stringify(plan.features),
      },
    },
  };
}

// Updates and existing plan
export function putPlan(plan) {
  return {
    types: PUT_PLAN,
    promise: {
      url: `/billing/plans/${plan.id}`,
      method: 'PUT',
      data: {
        ...plan,
        features: JSON.stringify(plan.features),
      },
    },
  };
}

// Deletes a plan from the DB
export function deletePlan(plan) {
  return {
    types: DELETE_PLAN,
    promise: {
      url: `/billing/plans/${plan.id}`,
      method: 'DELETE',
    },
  };
}

// Subcribes the current user to the given plan using the given payment method
export function subscribe(plan, payment) {
  return {
    types: POST_SUBSCRIBE,
    promise: {
      url: `/billing/plans/${plan.id}/subscribe`,
      method: 'POST',
      data: { payment },
    },
  };
}

// Changes the current user to the current plan
export function upgrade(plan) {
  return {
    types: POST_UPGRADE,
    promise: {
      url: `/billing/plans/${plan.id}/upgrade`,
      method: 'POST',
    },
  };
}

// Load the subscription for the current user
export function loadSubscription() {
  return {
    types: LOAD_SUBSCRIPTION,
    promise: {
      url: `/billing/plans/current`,
    },
  };
}

// Load all the invoices for the current user
export function loadInvoices() {
  return {
    types: LOAD_INVOICES,
    promise: {
      url: `/billing/invoices`,
    },
  };
}

// Cancels a subscription for the current user
export function deleteSubscription() {
  return {
    types: DELETE_SUBSCRIPTION,
    promise: {
      url: `/billing/plans/cancel`,
      method: 'DELETE',
    },
  };
}

// Updates default payment method
export function putPaymentMethod(method) {
  return {
    types: PUT_PAYMENT_METHOD,
    promise: {
      url: `/billing/methods/${method.id}`,
      method: 'PUT',
    },
  };
}

// Get all payment methods for the current user
export function getPaymentMethods() {
  return {
    types: GET_PAYMENT_METHODS,
    promise: {
      url: `/billing/methods`,
    },
  };
}

export function deletePaymentMethods(pm) {
  return {
    types: DELETE_PAYMENT_METHOD,
    promise: {
      url: `/billing/methods/${pm.id}`,
      method: 'DELETE',
    },
  };
}
